import { getMediaUrl } from '@/hooks/useMediaUpload';

/**
 * Normalize avatar references into a usable image URL.
 * Rules:
 * - If value looks like a UUID (fileId), assume it's a media file and return media URL thumbnail
 * - If value is a full URL or starts with '/', return as-is
 * - If value looks like an email/username/id, return a server endpoint that resolves avatar
 */
export function resolveAvatar(value: string | undefined | null): string | undefined {
  if (!value) return undefined;

  const trimmed = value.trim();

  // Full URL or absolute path
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('/')) {
    return trimmed;
  }

  // UUID-like fileId (simple heuristic: contains '-' and length > 20)
  if (trimmed.includes('-') && trimmed.length >= 20) {
    try {
      return getMediaUrl(trimmed, 'thumbnail');
    } catch (err) {
      return undefined;
    }
  }

  // Fallback: use server resolver endpoint which accepts username or id
  return `/api/users/${encodeURIComponent(trimmed)}/avatar`;
}

export default resolveAvatar;
